export const NONE = 'none';
export const NORMAL = 'partner';
export const TANDEM = 'tandem';

export const partnerTypes = [
  { value: NONE, label: 'label.none' },
  { value: NORMAL, label: 'label.partner' },
  { value: TANDEM, label: 'label.tandempartner' },
];
